import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  Box,
  HStack,
  VStack,
  Tooltip,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FcApprove, FcDisapprove } from "react-icons/fc";
import { MdOutlineLogout, MdWarningAmber } from "react-icons/md";
import { RiFileEditLine, RiForbid2Line, RiQrScan2Line, RiLockPasswordLine } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import CTable from "../../../components/Table/table";
import {
  openCreateStudent,
  openStudentReportModel,
  openUserQRCodeModel,
  openSuspendReasonModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  approvedStudentsListRequest,
  clearSessionRequest,
  deleteStudentRequest,
  rejectStudentRequest,
  restrictStudentRequest,
  studentsRequestsListRequest,
  resendPasswordRequest,
} from "../../../modules/admin-modules/students/Actions";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import SuspendReasonModal from "./models/suspend-reason";
import ApproveStudentModal from "./models/approve-student";

const ActionBtn = ({
  icon,
  label,
  shortLabel,
  ariaLabel,
  onClick,
  isLoading,
  color = "gray.600",
  bg = "gray.100",
  hoverBg,
}) => (
  <Tooltip
    label={label || ariaLabel}
    hasArrow
    placement="top"
    bg="gray.700"
    color="white"
    borderRadius="8px"
    fontSize="sm"
    openDelay={200}
  >
    <VStack spacing="2px" minW="42px" alignItems="center">
      <Text
        fontSize="10px"
        color="gray.600"
        textAlign="center"
        lineHeight="1.2"
        noOfLines={2}
        maxW="48px"
      >
        {shortLabel || label || ariaLabel}
      </Text>
      <IconButton
        variant="ghost"
        size="sm"
        minW="36px"
        h="36px"
        borderRadius="10px"
        bg={bg}
        color={color}
        aria-label={ariaLabel || label}
        fontSize="18px"
        icon={icon}
        onClick={onClick}
        isLoading={isLoading}
        _hover={{ bg: hoverBg || bg }}
      />
    </VStack>
  </Tooltip>
);

const ActionsGroup = ({ children }) => (
  <HStack
    spacing="4px"
    px="6px"
    py="6px"
    border="1px solid"
    borderColor="gray.200"
    borderRadius="16px"
    bg="white"
    w="fit-content"
    display="inline-flex"
    alignItems="flex-end"
  >
    {children}
  </HStack>
);

const CirclesStudentsTable = ({ setAdd, setSelectedData, searchTerm }) => {
  const approvedStudents = useSelector(
    (state) => state.students.approvedStudents
  );
  const pendeingStudents = useSelector(
    (state) => state.students.pendeingStudents
  );
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.students.isLoading);
  const count = useSelector((state) => state.students.count);
  const isRestrict = useSelector((state) => state.students.isRestrict);
  const isSuspend = useSelector((state) => state.students.isSuspend);

  const [offset, setPage] = useState(0);
  const [tab, setTab] = useState("approve");
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [studentGroupId, setStudentGroupId] = useState("");
  const [selected, setSelected] = useState({
    id: "",
  });
  const [suspendStudent, setSuspendStudent] = useState(null);
  const [approveStudent, setApproveStudent] = useState(null);
  const studentsList = tab === "approve" ? approvedStudents : pendeingStudents;
  const groups = useSelector((state) => state.groups.groups);
  const userData = useSelector((state) => state.user.userData);
  const isSuperAdmin = userData?.role?.[0]?.name === "Super Admin";

  useEffect(() => {
    dispatch(getAllGroupsRequest());
  }, [dispatch]);

  useEffect(() => {
    const timeId = setTimeout(() => {
      tab === "approve"
        ? dispatch(approvedStudentsListRequest(pageNumber + 1, searchTerm, studentGroupId))
        : dispatch(studentsRequestsListRequest(pageNumber + 1, searchTerm));
    }, 200);

    return () => {
      clearTimeout(timeId);
    };
  }, [pageNumber, searchTerm, tab, studentGroupId, dispatch]);

  // Function to format phone number for WhatsApp
  const formatPhoneForWhatsApp = (phone) => {
    if (!phone) return null;

    // Remove all spaces, dashes, brackets, and parentheses
    let cleaned = phone.toString().replace(/[\s\-\(\)\[\]]/g, '');

    // Check if it's an Egyptian number (starts with 012, 011, 010, 015)
    if (cleaned.match(/^(012|011|010|015)/)) {
      // Keep the 0 and add country code 2 before it
      cleaned = '2' + cleaned;
    } else {
      // Remove leading + or 00
      if (cleaned.startsWith('+')) {
        cleaned = cleaned.substring(1);
      } else if (cleaned.startsWith('00')) {
        cleaned = cleaned.substring(2);
      }
    }

    return cleaned;
  };

  const viewData = (data) => {
    // Find the original student data from studentsList to preserve original values (not JSX)
    const originalData = studentsList?.find((student) => student.id === data?.id);
    if (originalData) {
      setSelectedData(originalData);
      setSelected(originalData);
    } else {
      setSelectedData(data);
      setSelected(data);
    }
  };

  const PendingData = studentsList?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.phone}</Text>
          {data?.phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      actions: (
        <ActionsGroup>
          <ActionBtn
            label="موافقة"
            ariaLabel="Approve"
            icon={<FcApprove />}
            bg="green.50"
            color="green.600"
            hoverBg="green.100"
            isLoading={selected.id == data?.id ? isSuspend : false}
            onClick={() => {
              setSelected({ id: data?.id });
              setApproveStudent(data);
            }}
          />
          <ActionBtn
            label="رفض"
            ariaLabel="Reject"
            icon={<FcDisapprove />}
            bg="red.50"
            color="red.500"
            hoverBg="red.100"
            isLoading={selected.id == data?.id ? isRestrict : false}
            onClick={() => dispatch(rejectStudentRequest(data?.id))}
          />
        </ActionsGroup>
      ),
    };
  });
  const pendingColumns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: " رقم  الطالب",
      accessor: "phone",
    },
    {
      Header: " المجموعة",
      accessor: "group_name",
    },
    {
      Header: "ACTIONS",
      accessor: "actions",
    },
  ];

  const Data = studentsList?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      student_name: (
        <Text
          cursor="pointer"
          onClick={() => dispatch(openStudentReportModel())}
        >
          {data?.name}
        </Text>
      ),
      group_name: data?.group?.name,
      phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.phone}</Text>
          {data?.phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      parent_phone: (
        <HStack spacing={2} alignItems="center">
          <Text>{data?.parent_phone}</Text>
          {data?.parent_phone && (
            <IconButton
              as="a"
              href={`https://wa.me/${formatPhoneForWhatsApp(data?.parent_phone)}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="ghost"
              size="sm"
              colorScheme="green"
              aria-label="WhatsApp"
              icon={<FaWhatsapp />}
              onClick={(e) => e.stopPropagation()}
            />
          )}
        </HStack>
      ),
      code: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiQrScan2Line />}
          onClick={() => dispatch(openUserQRCodeModel())}
        />
      ),
      actions: (
        <ActionsGroup>
          <ActionBtn
            label={data?.deleted_at == null ? "ايقاف" : "تفعيل"}
            ariaLabel="ايقاف"
            icon={
              <MdWarningAmber
                color={data?.deleted_at == null ? "#E53E3E" : "#38A169"}
              />
            }
            bg={data?.deleted_at == null ? "red.50" : "green.50"}
            hoverBg={data?.deleted_at == null ? "red.100" : "green.100"}
            isLoading={selected.id == data?.id ? isSuspend : false}
            onClick={() => {
              if (data?.deleted_at != null) {
                dispatch(deleteStudentRequest(data?.id));
              } else {
                setSuspendStudent(data);
                dispatch(openSuspendReasonModel());
              }
            }}
          />
          <ActionBtn
            label="مسح الجلسة"
            shortLabel="session"
            ariaLabel="Clear Session"
            icon={<MdOutlineLogout />}
            bg="blue.50"
            color="blue.700"
            hoverBg="blue.100"
            onClick={() => dispatch(clearSessionRequest(data?.id))}
          />
          <ActionBtn
            label={data?.restrict == 0 ? "تقييد" : "إلغاء التقييد"}
            shortLabel={data?.restrict == 0 ? "تقييد" : "إلغاء"}
            ariaLabel="Restrict"
            icon={
              <RiForbid2Line
                color={data?.restrict == 0 ? "#E53E3E" : "#38A169"}
              />
            }
            bg={data?.restrict == 0 ? "red.50" : "green.50"}
            hoverBg={data?.restrict == 0 ? "red.100" : "green.100"}
            isLoading={selected.id == data?.id ? isRestrict : false}
            onClick={() => {
              const formData = new FormData();
              formData.append("_method", "PUT");
              data?.restrict == 0
                ? formData.append("restrict", 0)
                : formData.append("restrict", 1);
              dispatch(
                restrictStudentRequest({
                  id: data?.id,
                  formData: formData,
                })
              );
            }}
          />
          <ActionBtn
            label="إعادة إرسال كلمة المرور"
            shortLabel="Pass"
            ariaLabel="إعادة إرسال كلمة المرور"
            icon={<RiLockPasswordLine />}
            bg="purple.50"
            color="purple.600"
            hoverBg="purple.100"
            isLoading={selected.id === data?.id ? isLoading : false}
            onClick={() => {
              setSelected({ id: data?.id });
              dispatch(resendPasswordRequest(data?.id));
            }}
          />
          <ActionBtn
            label="تعديل"
            ariaLabel="تعديل"
            icon={<RiFileEditLine />}
            bg="blue.50"
            color="blue.600"
            hoverBg="blue.100"
            onClick={() => {
              setAdd(false);
              dispatch(openCreateStudent());
            }}
          />
        </ActionsGroup>
      ),
      subject_name: data?.subject?.name,
    };
  });
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "student_name",
    },
    {
      Header: "Asquera code",
      accessor: "user_name",
    },
    ...(isSuperAdmin
      ? [
        {
          Header: "المادة",
          accessor: "subject_name",
        },
      ]
      : []),
    {
      Header: " المجموعة",
      accessor: "group_name",
    },
    {
      Header: " Qr Code",
      accessor: "code",
    },
    {
      Header: " رقم  الطالب",
      accessor: "phone",
    },
    {
      Header: " رقم  ولي الامر",
      accessor: "parent_phone",
    },
    {
      Header: "ACTIONS",
      accessor: "actions",
    },
  ];

  const actions = (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<RiFileEditLine />}
        size="sm"
        fontSize="20px"
        variant="outline"
        border="none"
      />
      <MenuList>
        <MenuItem
          onClick={() => {
            setAdd(false);
            dispatch(openCreateStudent());
          }}
        >
          تعديل
        </MenuItem>
      </MenuList>
    </Menu>
  );

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  return (
    <>
      <Stack
        flexDirection="row"
        gap="10px"
        alignItems="center"
        justifyContent="center"
        my="10"
      >
        <Button
          onClick={() => setTab("pending")}
          style={{
            background: tab == "pending" ? "green" : "",
            color: tab == "pending" ? "white" : "",
          }}
        >
          Pending
        </Button>
        <Button
          mt="0 !important"
          onClick={() => setTab("approve")}
          style={{
            background: tab == "approve" ? "green" : "",
            color: tab == "approve" ? "white" : "",
          }}
        >
          Approved
        </Button>
        {tab === "approve" && (
          <Box w="300px">
            <Select
              options={groupsOptions}
              isMulti={false}
              isClearable
              onChange={(data) => {
                setStudentGroupId(data?.value || "");
              }}
              styles={colourStyles}
              placeholder="Select Group"
            />
          </Box>
        )}
      </Stack>
      <CTable
        selectedData={viewData}
        Columns={tab === "approve" ? columns : pendingColumns}
        Data={tab === "approve" ? Data : PendingData}
        path={"openModel"}
        Actions={actions}
        Title={``}
        subTitle=""
        btnTitle=""
        placeHolder=""
        noSearchBar={true}
        noFilter={true}
        footerBtnTitle
        filterList
        addButton
        addButtonTitle=""
        setPage={setPage}
        setPerPage={setPerPage}
        currentpage={pageNumber}
        setPageNumber={setPageNumber}
        noSecondSearchBar={true}
        isLoading={isLoading}
        perPage={size}
        totalPage={Math.ceil(count / 50)}
      />

      {/* Suspend Reason Modal */}
      <SuspendReasonModal studentData={suspendStudent} />

      <ApproveStudentModal
        isOpen={!!approveStudent}
        studentData={approveStudent}
        onClose={() => setApproveStudent(null)}
      />
    </>
  );
};

export default CirclesStudentsTable;
